// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"284":"a64d5f2e","303":"6ff3aa8e"}[chunkId] + ".chunk.js";
};